module.exports = __webpack_public_path__ + "static/fonts/HurmeGeometricSans2-Bold.10221a9e.woff2";